import React, { useState } from "react";
import { Map, Marker, ZoomControl, Overlay } from "pigeon-maps";
// import { osm } from 'pigeon-maps/providers'

import markerImg from '../assets/images/logo.png';

const MapShow = ({ location = [47.713871, 11.727249], zoom = 2, gotoLink, children = [] }) => {
   // provider={osm}
   const [center, setCenter] = useState(location);
   const [zm, setZm] = useState(zoom);

   const setOpacity = (op, el) => {
      el.target.style.opacity = op;
   }

   return (

      <Map height={300}

         defaultCenter={location}
         defaultZoom={zoom}
         zoom={zm}
         center={center}
         onBoundsChanged={({ center, zm }) => {
            setCenter(center)
            setZm(zm)
         }}
         animate={true}
         mouseEvents={true}
         touchEvents={true}
         boxClassname="mapbox"
      >
         <Marker width={50} anchor={location} onClick={() => window.open(gotoLink)} />
         <ZoomControl />
         <Overlay anchor={location} offset={[-10, 0]}>
            <img src={markerImg} width={"100px"} height={"auto"} alt=''
               onMouseEnter={(e) => setOpacity(0.05, e)} onMouseLeave={(e) => setOpacity(0.8, e)} />
         </Overlay>
      </Map >
   );
}

export default MapShow;